(function(w,d,$){
  'use strict';

  const cont = location.pathname.replace(/^\/([^/]+)\//,'$1');
  const init = ()=>{
    if(!$.UA.is_pc) return;

    // パンくず移動
    $('#allbox > .breadcrumbs').prependTo('#container');
  }

  $(function(){
    init();
  });

  $(w).on('load choco-headNav.load wata-headNav.load pop-headNav.load',function(){
    $('[data-plugin=currentNav]').currentMenu();
  });

  $(w).on('list_disp',function(){});

  $(w).on('detail_disp',function(){});


}(window,document,jQuery));